import { createFileRoute } from "@tanstack/react-router";
import { StudyAbroadPage } from "@/components/abroad/StudyAbroadPage";
import { abroadHead } from "@/components/abroad/abroad-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Лендинг «Учёба за рубежом» (az). Адреса трёх языков — ABROAD_PATH.
export const Route = createFileRoute("/az/xaricde-tehsil")({
  // Число открытых стран — для FAQ («в подборе N стран») и его JSON-LD. Сбой — без числа.
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => abroadHead("az", loaderData?.count ?? null),
  component: function Page() {
    const data = Route.useLoaderData();
    return <StudyAbroadPage lang="az" countries={data?.count ?? null} />;
  },
});
